export const findWithIndex = <Item = unknown>(
  array: Item[],
  predicate: (item: Item, index: number) => boolean
) => {
  for (let i = 0; i < array.length; i++) {
    const item = array[i]
    if (!item) continue
    if (predicate(item, i)) {
      return { item, index: i }
    }
  }
  return null
}
